import axios from "axios"
import { APIURL } from "src/config/helpers/base"

export const setDataCategorys = (pageNum = 1, sort = '', search = '', rows = '8') => {
    return (dispatch) => {
        dispatch({ type: 'DATA_CATEGORYS', payload: false })
        axios.get(`${APIURL}/one/Dataset/GetDatasetGroupsCategory?Search=${search}&Rows=${rows}&PageNum=${pageNum}&Sort=${sort}`).then(res => {
            if (res.status !== 204) {
                var data = res.data;
                dispatch({ type: 'DATA_CATEGORYS', payload: data.Datasets })
                dispatch({ type: 'TOT_RESULT_CATEGORYS', payload: data.TotResult })
            } else {

            }
        })
    }
}


export const setDataCategoryDatasetBySlug = (slug, rows = 10, pageNum = 1, sort = 1, search = '') => {
    return (dispatch) => {
        dispatch({ type: 'DATA_CATEGORY_DATASETS', payload: false })
        axios.get(`${APIURL}/one/Dataset/GetDatasetsByCategory?Slug=${slug}&Search=${search}&Rows=${rows}&PageNum=${pageNum}&Sort=${sort}`).then(res => {
            if (res.status !== 204) {
                var data = res.data;
                dispatch({ type: 'DATA_CATEGORY_DATASETS', payload: data })
                dispatch({ type: 'TOT_RESULT_CATEGORY_DATASETS', payload: data.TotResult })
            } else {
                // dispatch({ type: 'DATA_CATEGORY_DATASETS', payload: [] })
            }
        })
    }
}

export const setDataCategoryBySlug = (slug) => {
    return (dispatch) => {
        dispatch({ type: 'DATA_CATEGORY', payload: false })
        axios.get(`${APIURL}/DatasetCategory/GetBySlug?Slug=${slug}`).then(res => {
            var data = res.data;
            if (data.IsSuccess) {
                setTimeout(() => {
                    dispatch({ type: 'DATA_CATEGORY', payload: data.Data })
                }, 1000);
            } else {
                dispatch({ type: 'DATA_CATEGORY', payload: false })
            }
        })
    }
}